import { Component, OnInit } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons/faInfoCircle';
import { HelperService } from '../../../services/helper/helper.service';

/**
 * Component:
 * Feedback/answersheet overview page;
 * Can be found: {uri}/feedback-overview
 */

@Component({
  selector: 'app-feedback-overview',
  templateUrl: './feedback-overview.component.html',
  styleUrls: ['./feedback-overview.component.scss']
})
export class FeedbackOverviewComponent implements OnInit {
  // Icons
  faInfoCircle = faInfoCircle;

  public showDescription$: Observable<boolean>;

  public showDescriptionSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(private helperService: HelperService) {
    this.showDescription$ = this.showDescriptionSubject.asObservable();
  }

  public get helper() {
    return this.helperService;
  }

  ngOnInit(): void {}
}
